module.exports = __webpack_public_path__ + "static/img/pay1.7a7a94c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/pay1.png
// module id = 9xoa
// module chunks = 1